import React, { useState } from 'react';
import './VPSManaged.css';

const VPSManaged = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۴۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      features: ['مدیریت کامل سرور', 'به‌روزرسانی امنیتی', 'پشتیبانی ۲۴/۷', 'نصب و راه‌اندازی'],
      popular: false,
    },
    {
      tier: 'کسب‌وکار',
      price: '۶۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      features: ['مدیریت کامل سرور', 'به‌روزرسانی امنیتی', 'پشتیبانی ۲۴/۷', 'نصب و راه‌اندازی', 'بهینه‌سازی عملکرد', 'بکاپ خودکار'],
      popular: true,
    },
    {
      tier: 'سازمانی',
      price: '۱,۰۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      features: ['مدیریت کامل سرور', 'به‌روزرسانی امنیتی', 'پشتیبانی ۲۴/۷', 'نصب و راه‌اندازی', 'بهینه‌سازی عملکرد', 'بکاپ خودکار', 'مشاوره تخصصی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🛡️',
      title: 'مدیریت کامل و جامع سرور',
      desc: 'تیم حرفه‌ای افرسل تمام جنبه‌های مدیریت سرور شما را بر عهده می‌گیرد. از نصب و راه‌اندازی اولیه تا به‌روزرسانی‌های امنیتی، نظارت بر عملکرد، عیب‌یابی و رفع مشکلات، همه توسط تیم ما انجام می‌شود. شما فقط روی کسب‌وکار خود متمرکز می‌شوید و بقیه را به ما بسپارید.',
    },
    {
      icon: '🔒',
      title: 'امنیت پیشرفته و به‌روزرسانی خودکار',
      desc: 'امنیت سرور شما به صورت شبانه‌روزی توسط تیم ما پایش می‌شود. به‌روزرسانی‌های امنیتی به صورت خودکار انجام می‌شود و فایروال، آنتی‌ویروس و سایر ابزارهای امنیتی به طور مداوم به‌روز می‌شوند تا از داده‌های شما در برابر تهدیدات سایبری محافظت کنند.',
    },
    {
      icon: '⚡',
      title: 'بهینه‌سازی عملکرد و سرعت',
      desc: 'تیم ما با بهینه‌سازی تنظیمات سرور، کش، پایگاه داده و وب‌سرور، عملکرد سرور شما را به حداکثر می‌رساند. سرعت بارگذاری وب‌سایت شما افزایش می‌یابد و تجربه کاربری بهتری برای بازدیدکنندگان فراهم می‌شود.',
    },
    {
      icon: '👨‍💻',
      title: 'پشتیبانی ۲۴ ساعته توسط تیم متخصص',
      desc: 'تیم پشتیبانی فنی افرسل به صورت ۲۴ ساعته و ۷ روز هفته در دسترس شماست. هرگونه مشکل یا سوالی داشته باشید، تیم ما در کمترین زمان ممکن پاسخگو خواهد بود.',
    },
  ];

  const faqs = [
    {
      q: 'VPS مدیریت شده چه خدماتی را شامل می‌شود و برای چه کسانی مناسب است؟',
      a: 'VPS مدیریت شده یک سرویس کامل است که شامل نصب و راه‌اندازی سرور، به‌روزرسانی امنیتی، نظارت بر عملکرد، عیب‌یابی، پشتیبانی ۲۴ ساعته و بهینه‌سازی سرور می‌شود. این سرویس برای افرادی که دانش فنی کافی برای مدیریت سرور ندارند یا وقت کافی برای انجام این کارها ندارند، بسیار مناسب است. همچنین برای کسب‌وکارهایی که می‌خواهند روی توسعه وب‌سایت خود متمرکز شوند و نگران مسائل فنی نباشند، گزینه‌ای ایده‌آل است.',
    },
    {
      q: 'آیا در VPS مدیریت شده به روت اکسس دسترسی دارم؟',
      a: 'بله، شما به روت اکسس (دسترسی کامل) به سرور خود دسترسی دارید. تیم مدیریت افرسل با استفاده از این دسترسی، کارهای مدیریتی را انجام می‌دهد، اما شما نیز در هر زمان می‌توانید به سرور خود متصل شده و تغییرات دلخواه را اعمال کنید. البته توصیه می‌کنیم برای تغییرات مهم با تیم پشتیبانی هماهنگ کنید تا از بروز مشکلات احتمالی جلوگیری شود.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS مدیریت شده | خرید سرور مجازی مدیریت شده با بهترین قیمت | افرسل</h1>
        <p>خرید VPS مدیریت شده با پشتیبانی کامل، امنیت پیشرفته و بهینه‌سازی عملکرد. سرور مجازی مدیریت شده مناسب برای کسب‌وکارهایی که دانش فنی کافی ندارند یا وقت کافی برای مدیریت سرور ندارند.</p>
        <meta name="description" content="خرید VPS مدیریت شده با بهترین قیمت از افرسل. سرور مجازی مدیریت شده با پشتیبانی کامل، امنیت پیشرفته، بهینه‌سازی عملکرد و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-managed-hero">
        <div className="vps-managed-hero-bg"></div>
        <div className="wrap">
          <div className="vps-managed-hero-content">
            <div className="vps-managed-badge">
              <span className="pulse-dot"></span>
              🛡️ VPS مدیریت شده
            </div>
            <h1 className="vps-managed-hero-title">
              سرور مجازی <em>مدیریت شده</em>
            </h1>
            <p className="vps-managed-hero-desc">
              VPS مدیریت شده با پشتیبانی کامل، امنیت پیشرفته و بهینه‌سازی عملکرد.
              شما فقط روی کسب‌وکار خود متمرکز شوید، بقیه را به ما بسپارید.
              مناسب برای کسانی که دانش فنی کافی ندارند یا وقت کافی برای مدیریت سرور ندارند.
            </p>
            <div className="vps-managed-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰٪</span>
                <span className="stat-label">مدیریت کامل</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-managed-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS مدیریت شده</span>
            <h2 className="sec-h">پلن <em>مناسب</em> کسب‌وکار خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS مدیریت شده با قیمت‌های رقابتی و خدمات کامل مدیریتی.</p>
          </div>
          <div className="vps-managed-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-managed-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-managed-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-managed-plan-tier">{plan.tier}</div>
                <div className="vps-managed-plan-price">
                  <span className="vps-managed-plan-num">{plan.price}</span>
                  <span className="vps-managed-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-managed-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="vps-managed-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-managed-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-managed-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS مدیریت شده</span>
            <h2 className="sec-h">چرا <em>VPS مدیریت شده</em> با افرسل؟</h2>
            <p className="sec-p">VPS مدیریت شده با بهترین خدمات مدیریتی برای کسب‌وکارها.</p>
          </div>
          <div className="vps-managed-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-managed-feature-card">
                <span className="vps-managed-feature-icon">{feature.icon}</span>
                <h3 className="vps-managed-feature-title">{feature.title}</h3>
                <p className="vps-managed-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-managed-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-managed-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-managed-faq-item">
                <div className="vps-managed-faq-q">{faq.q}</div>
                <div className="vps-managed-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-managed-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>مدیریت شده</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS مدیریت شده، از پشتیبانی کامل، امنیت پیشرفته و بهینه‌سازی عملکرد بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSManaged;
